import { BaseDto, OrderByValue } from '../../core';
import { PURCHASE_ORDER_ADMIN_STATUS } from '../../shared';

export class PurchaseOrderListDto extends BaseDto<PurchaseOrderListDto> {
  purchaseOrderStatus?: PURCHASE_ORDER_ADMIN_STATUS;
  orderById?: OrderByValue;
  isMyMembership?: boolean;
}
